/**
 * 教练管理 API
 */
import http from './httpRequest.js'

/**
 * 获取我的学员列表
 */
export function getMyStudentList(params) {
  return http({
    url: '/coach/student/list',
    method: 'GET',
    params
  })
}

/**
 * 获取学员分配信息
 */
export function getStudentAssignment(studentId) {
  return http({
    url: `/coach/student/assignment/${studentId}`,
    method: 'GET'
  })
}

/**
 * 获取培训签到记录
 */
export function getTrainRecordList(params) {
  return http({
    url: '/coach/train/list',
    method: 'GET',
    params
  })
}

/**
 * 获取考试成绩记录
 */
export function getExamRecordList(params) {
  return http({
    url: '/coach/exam/list',
    method: 'GET',
    params
  })
}

/**
 * 更新考试成绩记录
 */
export function updateExamRecord(data) {
  return http({
    url: '/coach/exam/update',
    method: 'POST',
    data
  })
}

/**
 * 获取我的培训记录
 */
export function getMyTrainRecordList(params) {
  return http({
    url: '/coach/train/my',
    method: 'GET',
    params
  })
}

/**
 * 获取我的考试成绩登记
 */
export function getMyExamRecordList(params) {
  return http({
    url: '/coach/exam/my',
    method: 'GET',
    params
  })
}

/**
 * 获取培训统计
 */
export function getTrainStatistics() {
  return http({
    url: '/coach/train/statistics',
    method: 'GET'
  })
}

/**
 * 获取教练统计
 */
export function getCoachStatistics() {
  return http({
    url: '/coach/statistics',
    method: 'GET'
  })
}
